<template>
  <div>
    <el-row :gutter="20" v-if="clearance === roles.clubAdmin">
      <el-col>
        <select
          class="tw-w-full tw-px-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none tw-h-9"
          v-model="teamId"
          :class="teamId !== null ? 'tw-font-medium' : 'tw-font-normal'"
        >
          <option disabled selected :value="null">Select A Team</option>
          <option
            v-for="{ _id, name, ageLvl } in teams"
            :label="`${name} (${ageLvl})`"
            :key="_id"
            :value="_id"
          >
            {{ `${name} (${ageLvl})` }}
          </option>
        </select>
      </el-col>
    </el-row>
    <div v-if="!matches.length" class="tw-py-2.5">
      <div class="tw-p-5 tw-leading-6 tw-bg-white tw-border tw-border-gray-200 tw-shadow-md">
        Sorry, but it looks like your league is still finalising the draw. Please check back soon or
        contact your Club or League.
      </div>
    </div>
    <el-row
      :gutter="20"
      v-if="
        (clearance === roles.clubAdmin && matches.length) || (roles.gamedayAdmin && matches.length)
      "
    >
      <el-col>
        <select
          class="tw-w-full tw-px-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none tw-h-9"
          v-model="competitionId"
          :class="competitionId !== null ? 'tw-font-medium' : 'tw-font-normal'"
        >
          <option disabled selected :value="null">Select A Competition</option>
          <option v-for="{ _id, name } in competitions()" :label="name" :key="_id" :value="_id">
            {{ name }}
          </option>
        </select>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <div v-if="upcomingMatches.length">
        <h3 class="tw-py-5 tw-text-lg tw-font-bold">Upcoming Matches</h3>
        <swipe-list :items="upcomingMatches" ref="upcomingList">
          <template v-slot="{ item }">
            <el-col><match :match="item" @click="goDetail(item._id)" /></el-col>
          </template>
          <template v-slot:right="{ item }">
            <div class="swipeout swipe-item" @click="disputeMatch(item._id)">
              <div>Dispute</div>
            </div>
          </template>
        </swipe-list>
      </div>
    </el-row>
    <el-row :gutter="20">
      <div v-if="previousMatches.length">
        <h3 class="tw-py-5 tw-text-lg tw-font-bold">Previous Matches</h3>
        <swipe-list :items="previousMatches" ref="previousList">
          <template v-slot="{ item }">
            <el-col><match :match="item" @click="goDetail(item._id)" /></el-col>
          </template>
          <template v-slot:right="{ item }">
            <div class="swipeout swipe-item" @click="disputeMatch(item._id)">
              <div>Dispute</div>
            </div>
          </template>
        </swipe-list>
      </div>
    </el-row>

    <!-- Disputed dialog -->
    <el-dialog title="DISPUTE MATCH" :visible.sync="disputeDialog" width="80%" top="30vh">
      <el-form v-model="dispute">
        <el-form-item label="Dispute reason">
          <textarea class="textBox" rows="2" v-model="dispute.reason"></textarea>
        </el-form-item>
      </el-form>

      <div>
        <button class="btn-success" type="success" @click="submitDisputeMatch">Submit</button>
        <button
          class="btn-cancel"
          @click="
            disputeDialog = false;
            resetDispute();
          "
        >
          Cancel
        </button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import "vue-swipe-actions/dist/vue-swipe-actions.css";
import { SwipeList } from "vue-swipe-actions";
import _ from "lodash";
import Match from "../../components/MatchCard.vue";
import { roles, currentSeason } from "../../utils/constants";

export default {
  name: "Matches",
  components: {
    Match,
    SwipeList,
  },
  data() {
    return {
      roles,
      teams: [],
      teamId: null,
      competitionId: null,
      filteredMatches: [],
      matches: [],
      disputeDialog: false,
      dispute: {
        _id: "",
        reason: "",
      },
    };
  },
  mounted() {
    this.$store.commit("root/loading", true);
    if (this.clearance === roles.clubAdmin) {
      // Check for current Season Active Teams
      this.$http.get(`/nrl/api/v1/admin/club/teams?season=${currentSeason}`).then((res) => {
        this.teams = res.data.data;
        this.$store.commit("root/loading", false);
      });
      this.teamId = this.$store.state.app.selectedTeamId;
    } else if (this.clearance === roles.teamAdmin) {
      this.teamId = this.$store.getters["user/activeRole"].entity._id;
      this.$http.get(`nrl/api/v1/admin/teams/${this.teamId}/matches`).then((res) => {
        this.matches = res.data.data;
        // filter out tba or bye game
        if (this.matches && this.matches.length) {
          this.matches = this.matches.filter((x) => !x.meta || (!x.meta.isTba && !x.meta.isBye));
        }
        this.filteredMatches = this.matches;
        this.$store.commit("root/loading", false);
      });
    } else if (this.clearance === roles.gamedayAdmin) {
      this.$http.get(`/nrl/api/v1/admin/gamedayadmin/`).then((res) => {
        this.matches = res.data.data;
        if (this.matches && this.matches.length) {
          this.matches = this.matches.filter((x) => !x.meta || (!x.meta.isTba && !x.meta.isBye));
        }
        this.filteredMatches = this.matches;
      });

      this.$store.commit("root/loading", false);
    }
  },
  methods: {
    competitions() {
      if (this.matches.length) {
        return _.chain(this.matches).map("competition").uniqBy("_id").sortBy("name")
          .values();
      }
      return [];
    },
    matchTime(dateTime) {
      return this.dayjs(dateTime).format("h:mm a");
    },
    matchDate(dateTime) {
      return this.dayjs(dateTime).format("dddd Do MMMM");
    },
    goDetail(matchId) {
      const match = this.matches.find(x => x._id === matchId);

      if (match && match.status !== "pre-game") {
        this.$customError(`Match has been set to ${match.status}.`);
        return;
      }

      if (match && Math.abs(this.dayjs().diff(match.dateTime, "days", true)) > 8) {
        this.$customError("Match has exceeded 8 days");
        return;
      }

      this.$router.push({
        name: "match.detail",
        params: {
          matchId,
          teamId: this.teamId,
        },
      });
    },
    disputeMatch(matchId) {
      this.dispute._id = matchId;
      this.disputeDialog = true;
    },
    submitDisputeMatch() {
      this.$store.commit("root/loading", true);
      this.$http
        .put(`/nrl/api/v1/admin/matches/${this.dispute._id}/status/disputed`, {
          note: this.dispute.reason,
        })
        .then(() => {
          const matchIndex = this.matches.findIndex((x) => x._id === this.dispute._id);
          this.matches[matchIndex].status = "disputed";
          this.disputeDialog = false;
          this.resetDispute();
          this.$customSuccess();
          this.$store.commit("root/loading", false);
        })
        .catch(() => {
          this.$store.commit("root/loading", false);
        });
    },
    resetDispute() {
      this.dispute._id = undefined;
      this.dispute.reason = "";
      if (this.upcomingMatches.length) this.$refs.upcomingList.closeActions();
      if (this.previousMatches.length) this.$refs.previousList.closeActions();
    },
  },
  computed: {
    clearance() {
      return this.$store.getters["user/activeRole"].type;
    },
    upcomingMatches() {
      const time = this.dayjs().subtract(12, "hours").valueOf();
      return _.orderBy(
        this.filteredMatches.filter(x => x.dateTime >= time),
        "dateTime"
      );
    },
    previousMatches() {
      const time = this.dayjs().subtract(12, "hours").valueOf();
      return _.orderBy(
        this.filteredMatches.filter(x => x.dateTime < time),
        "dateTime"
      );
    },
  },
  watch: {
    teamId: {
      immediate: true,
      handler(val) {
        // reset competition id if user select another team
        if (val !== this.$store.state.app.selectedTeamId && val !== null) {
          this.$store.commit("app/selectTeam", val);
          this.$store.commit("app/selectCompetition", null);
          this.competitionId = null;
        }
        this.$store.commit("root/loading", true);

        if (val) {
          this.$http.get(`nrl/api/v1/admin/teams/${val}/matches`).then((res) => {
            this.matches = res.data.data;
            // filter out tba or bye game
            if (this.matches && this.matches.length) {
              this.matches = this.matches.filter(
                (x) => !x.meta || (!x.meta.isTba && !x.meta.isBye)
              );
            }
            this.competitionId = this.$store.state.app.selectedCompetitionId;
            this.filteredMatches = this.competitionId
              ? this.matches.filter((match) => match.competition._id === this.competitionId)
              : this.matches;
            this.$store.commit("root/loading", false);
          });
        }
      },
    },
    competitionId: {
      immediate: true,
      handler(val) {
        if (val !== null) {
          this.$store.commit("app/selectCompetition", val);
          if (val) this.filteredMatches = this.matches.filter((x) => x.competition._id === val);
          else this.filteredMatches = this.matches;
        }
      },
    },
    disputeDialog: {
      handler(val) {
        if (!val) {
          if (this.upcomingMatches.length) this.$refs.upcomingList.closeActions();
          if (this.previousMatches.length) this.$refs.previousList.closeActions();
        }
      },
    },
  },
};
</script>
<style scoped lang="scss">
select {
  appearance: none; /* Remove default arrow */
  background-image: url("../../assets/chevron_down.svg"); /* Add custom arrow */
  background-position: center right;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  background-position-y: 8px;
}

.swipe-item {
  justify-content: center;
  min-width: 100px;
  margin: 5px 0px;
  padding: 10px;
  background-color: orange;
  color: $white;
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
h3 {
  text-align: center;
}
.el-col .el-col-24 {
  margin: 5px 0px;
}

.dialog-footer {
  display: flex;
  justify-content: center;
}

.textBox {
  @apply tw-w-full tw-p-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border tw-border-gray-200 tw-shadow-none focus:tw-outline-none tw-h-9;
}

.btn-success {
  @apply tw-justify-center tw-w-full tw-mt-2 tw-mr-2.5 tw-h-10 tw-rounded-lg tw-capitalize tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center  tw-text-white  tw-bg-green-700  tw-mb-4 hover:tw-bg-green-300 hover:tw-text-black sm:tw-w-64;
}

.btn-cancel {
  @apply tw-justify-center tw-w-full tw-h-10 tw-rounded-lg tw-capitalize tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center  tw-text-black  tw-bg-none tw-border-2 tw-border-green-700  hover:tw-border-green-300 sm:tw-w-64;
}
</style>
